import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon20: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 20" width={width} height={height} {...props}>
      <Path
        d="M7 0C10.865 0 14 3.134 14 7C14 8.099 13.746 9.138 13.295 10.064L19.33 16.099C20.223 16.991 20.223 18.439 19.331 19.33C18.438 20.223 16.991 20.223 16.1 19.33L10.063 13.296C9.13799 13.747 8.098 14 7 14C3.134 14 0 10.866 0 7C0 3.134 3.134 0 7 0ZM10.957 12.775L16.807 18.624C17.308 19.125 18.121 19.125 18.624 18.623C19.125 18.122 19.125 17.308 18.623 16.807L12.774 10.958C12.285 11.67 11.668 12.286 10.957 12.775ZM7 1C3.686 1 1 3.686 1 7C1 10.314 3.686 13 7 13C10.313 13 13 10.314 13 7C13 3.686 10.313 1 7 1ZM6.97699 2.72501C7.25399 2.72501 7.47699 2.94901 7.47699 3.22501L7.478 3.69C7.748 3.74 8.017 3.82099 8.28 3.92499C8.557 4.03399 8.77099 4.14399 8.89999 4.22299C9.13599 4.36699 9.21099 4.675 9.06699 4.91C8.92299 5.146 8.615 5.221 8.38 5.077C8.29601 5.026 8.132 4.94101 7.914 4.85501C7.555 4.71401 7.19099 4.63 6.85199 4.63C6.16799 4.63 5.70499 4.95101 5.70499 5.35001C5.70499 5.80401 6.07501 6.07701 7.23401 6.54001L7.35001 6.586C8.83301 7.177 9.392 7.576 9.392 8.535C9.392 9.56 8.641 10.179 7.478 10.317L7.47699 10.774C7.47699 11.051 7.25399 11.274 6.97699 11.274C6.70099 11.274 6.47699 11.051 6.47699 10.774V10.322C6.04099 10.275 5.65899 10.164 5.32999 10.004C5.04799 9.867 4.855 9.722 4.746 9.608C4.555 9.409 4.56199 9.092 4.76099 8.901C4.95999 8.71 5.27699 8.71698 5.46799 8.91599C5.49899 8.94798 5.597 9.02201 5.767 9.10501C6.076 9.25501 6.46899 9.34698 6.95599 9.34698C7.92599 9.34698 8.392 9.043 8.392 8.535C8.392 8.183 8.06 7.94501 6.979 7.51501L6.86301 7.46799C5.31701 6.85199 4.70499 6.40001 4.70499 5.35001C4.70499 4.41701 5.47699 3.78099 6.47699 3.65399V3.22501C6.47699 2.94901 6.70099 2.72501 6.97699 2.72501Z"
        fill="#73C177"
      />
    </Icon>
  )
}
